var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"about-us"},[(_vm.page)?[(_vm.$route.query.title)?_c('custom-breadcrumbs',{attrs:{"list":[{ title: _vm.getCurrentTittle }, { title: _vm.page.title }]}}):_c('custom-breadcrumbs',{attrs:{"list":[{ title: _vm.page.title }]}})]:_vm._e(),_c('page-wrap')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }